(() => {
  const mount = () => {
    document.querySelectorAll('product-info[data-template-view="ss-review"]').forEach(root => {
      if (root.dataset.reviewReady) return;
      root.dataset.reviewReady = 'true';
      const enhance = () => {
        root.querySelectorAll('select[data-ss-ring-size]').forEach(select => {
          select.required = true;
          const label = root.querySelector(`label[for="${select.id}"]`);
          const sizeLink = root.querySelector('a[href*="ringsizer.app/sizer/"]');
          if (label && sizeLink && !label.contains(sizeLink)) {
            label.classList.add('ss-review-size-label');
            sizeLink.classList.add('ss-review-size-link');
            label.append(sizeLink);
          }
        });
        root.querySelectorAll('select[name*="Chain Length"]').forEach(select => {
          Array.from(select.options).forEach(option => {
            if (option.dataset.ssCentimetres) return;
            const inches = Number.parseFloat(option.value);
            if (!Number.isFinite(inches)) return;
            option.textContent = `${option.value} / ${(inches * 2.54).toFixed(1)} cm`;
            option.dataset.ssCentimetres = 'true';
          });
        });
      };
      root.addEventListener('submit', event => {
        if (!event.target.matches('form.main-product-form')) return;
        const size = root.querySelector('select[data-ss-ring-size]');
        if (size && !size.value) {
          event.preventDefault();
          event.stopImmediatePropagation();
          size.focus();
          size.reportValidity();
        }
      }, true);
      let queued = false;
      const observer = new MutationObserver(records => {
        if (!records.some(record => Array.from(record.addedNodes).some(node => node.nodeType === 1 && (node.matches?.('variant-selects, .product-form__input') || node.querySelector?.('variant-selects'))))) return;
        if (queued) return;
        queued = true;
        requestAnimationFrame(() => { queued = false; enhance(); });
      });
      observer.observe(root, {childList:true, subtree:true});
      const group = (first, last, className) => {
        if (!first || !last || first.closest('.ss-review-choice')) return;
        const wrapper = document.createElement('div');
        wrapper.className = 'ss-review-choice ' + className;
        first.before(wrapper);
        wrapper.append(first);
        if (last !== first) wrapper.append(last);
      };
      group(root.querySelector('.product__block--variant_picker'), root.querySelector('.ss-review-size-guide')?.closest('.product__block'), 'ss-review-choice--size');
      group(root.querySelector('input[name="properties[Single Initial]"]')?.closest('.product__block'), root.querySelector('.ss-review-front')?.closest('.product__block'), 'ss-review-choice--initial');
      enhance();
      let retries = 0;
      const appTimer = setInterval(() => {
        enhance();
        if (root.querySelector('.ss-review-size-link') || ++retries > 20) clearInterval(appTimer);
      }, 250);
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mount);
  else mount();
  document.addEventListener('shopify:section:load', mount);
})();

